const el = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Φόρτωση...',
    error: 'Σφάλμα',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    edit: 'Επεξεργασία',
    create: 'Δημιουργία',
    add: 'Προσθήκη',
    remove: 'Αφαίρεση',
    close: 'Κλείσιμο',
    confirm: 'Επιβεβαίωση',
    apply: 'Εφαρμογή',
    reset: 'Επαναφορά',
    search: 'Αναζήτηση',
    filter: 'Φίλτρο',
    clear: 'Εκκαθάριση',
    back: 'Πίσω',
    next: 'Επόμενο',
    previous: 'Προηγούμενο',
    submit: 'Υποβολή',
    update: 'Ενημέρωση',
    refresh: 'Ανανέωση',
    export: 'Εξαγωγή',
    import: 'Εισαγωγή',
    download: 'Λήψη',
    upload: 'Μεταφόρτωση',
    print: 'Εκτύπωση',
    copy: 'Αντιγραφή',
    yes: 'Ναι',
    no: 'Όχι',
    ok: 'Εντάξει',
    done: 'Ολοκληρώθηκε',
    select: 'Επιλογή',
    selectAll: 'Επιλογή όλων',
    deselectAll: 'Αποεπιλογή όλων',
    noResults: 'Δεν βρέθηκαν αποτελέσματα',
    noData: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
    required: 'Υποχρεωτικό',
    optional: 'Προαιρετικό',
    actions: 'Ενέργειες',
    details: 'Λεπτομέρειες',
    overview: 'Επισκόπηση',
    summary: 'Σύνοψη',
    total: 'Σύνολο',
    all: 'Όλα',
    none: 'Κανένα',
    name: 'Όνομα',
    type: 'Τύπος',
    status: 'Κατάσταση',
    date: 'Ημερομηνία',
    time: 'Ώρα',
    description: 'Περιγραφή',
    notes: 'Σημειώσεις',
    comments: 'Σχόλια',
    category: 'Κατηγορία',
    priority: 'Προτεραιότητα',
    nation: 'Χώρα',
    country: 'Χώρα',
    email: 'Ηλ. ταχυδρομείο',
    phone: 'Τηλέφωνο',
    address: 'Διεύθυνση',
    location: 'Τοποθεσία',
    coordinates: 'Συντεταγμένες',
    latitude: 'Γεωγραφικό πλάτος',
    longitude: 'Γεωγραφικό μήκος',
    from: 'Από',
    to: 'Προς',
    createdAt: 'Δημιουργήθηκε',
    updatedAt: 'Ενημερώθηκε',
    createdBy: 'Δημιουργήθηκε από',
    modifiedBy: 'Τροποποιήθηκε από',
    active: 'Ενεργό',
    inactive: 'Ανενεργό',
    enabled: 'Ενεργοποιημένο',
    disabled: 'Απενεργοποιημένο',
    showing: 'Εμφάνιση',
    of: 'από',
    page: 'Σελίδα',
    perPage: 'ανά σελίδα',
    rows: 'γραμμές',
    items: 'στοιχεία',
    results: 'αποτελέσματα',
    sortBy: 'Ταξινόμηση κατά',
    ascending: 'Αύξουσα',
    descending: 'Φθίνουσα',
    viewAll: 'Προβολή όλων',
    viewDetails: 'Προβολή λεπτομερειών',
    goBack: 'Επιστροφή',
    learnMore: 'Μάθετε περισσότερα',
    seeMore: 'Δείτε περισσότερα',
    showMore: 'Εμφάνιση περισσότερων',
    showLess: 'Εμφάνιση λιγότερων',
    expandAll: 'Ανάπτυξη όλων',
    collapseAll: 'Σύμπτυξη όλων',
    copied: 'Αντιγράφηκε!',
    saved: 'Αποθηκεύτηκε!',
    deleted: 'Διαγράφηκε!',
    updated: 'Ενημερώθηκε!',
    created: 'Δημιουργήθηκε!',
    success: 'Επιτυχία',
    warning: 'Προειδοποίηση',
    info: 'Πληροφορίες',
    danger: 'Κίνδυνος',
    unknown: 'Άγνωστο',
    notAvailable: 'Μ/Δ',
    never: 'Ποτέ',
    today: 'Σήμερα',
    yesterday: 'Χθες',
    tomorrow: 'Αύριο',
    now: 'Τώρα',
    ago: 'πριν',
    justNow: 'μόλις τώρα',
    minutesAgo: '{{count}}λ πριν',
    hoursAgo: '{{count}}ω πριν',
    daysAgo: '{{count}}η πριν',
    monthsAgo: '{{count}}μ πριν',
    id: 'Αναγνωριστικό',
    version: 'Έκδοση',
    language: 'Γλώσσα',
    theme: 'Θέμα',
    darkMode: 'Σκοτεινή λειτουργία',
    lightMode: 'Φωτεινή λειτουργία',
    failedToLoad: 'Αποτυχία φόρτωσης δεδομένων',
    failedToSave: 'Αποτυχία αποθήκευσης',
    failedToDelete: 'Αποτυχία διαγραφής',
    failedToUpdate: 'Αποτυχία ενημέρωσης',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να το διαγράψετε;',
    confirmAction: 'Είστε βέβαιοι;',
    unsavedChanges: 'Έχετε μη αποθηκευμένες αλλαγές. Είστε βέβαιοι ότι θέλετε να φύγετε;',
    pageNotFound: '404 - Η σελίδα δεν βρέθηκε',
    pageNotFoundDesc: 'Η σελίδα που αναζητάτε δεν υπάρχει.',
    backToDashboard: 'Επιστροφή στον πίνακα ελέγχου',
    characters: 'χαρακτήρες',
    maxCharacters: 'Μέγιστο {{max}} χαρακτήρες',
    remaining: '{{count}} υπόλοιπο',
    selected: '{{count}} επιλεγμένα',
    of_total: '{{count}} από {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Πίνακας ελέγχου',
    requests: 'Αιτήματα',
    transports: 'Μεταφορές',
    myPatients: 'Οι ασθενείς μου',
    statistics: 'Στατιστικά',
    flow: 'Ροή',
    resources: 'Resources',
    exercise: 'Άσκηση',
    administration: 'Διαχείριση',
    map: 'Χάρτης',
    info: 'Πληροφορίες',
    users: 'Χρήστες',
    assets: 'Μέσα',
    hubs: 'Κόμβοι',
    treatmentFacilities: 'Μονάδες θεραπείας',
    patientImport: 'Εισαγωγή ασθενών',
    assetTemplates: 'Πρότυπα μέσων',
    dayTemplates: 'Πρότυπα ημέρας',
    announcementTicker: 'Ταινία ανακοινώσεων',
    exerciseStatistics: 'Στατιστικά άσκησης',
    settings: 'Ρυθμίσεις',
    auditLog: 'Αρχείο ελέγχου',
    exerciseControl: 'Έλεγχος άσκησης',
    dataSync: 'Συγχρονισμός δεδομένων',
    documentation: 'Τεκμηρίωση',
    support: 'Υποστήριξη',
    about: 'Σχετικά',
    assetContracts: 'Asset Contracts',
    notifications: 'Ειδοποιήσεις',
    schedules: 'Δρομολόγια',
    capacityPlanning: 'Σχεδιασμός χωρητικότητας',
    transportPlanning: 'Σχεδιασμός μεταφορών',
    transportBooking: 'Κράτηση μεταφοράς',
    flowDiagram: 'Διάγραμμα ροής',
    changePassword: 'Αλλαγή κωδικού',
    missions: 'Αποστολές',
    startPoints: 'Σημεία εκκίνησης',
    hospital: 'Νοσοκομείο',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Σύνδεση',
    logout: 'Αποσύνδεση',
    logoutNow: 'Αποσύνδεση τώρα',
    loggingIn: 'Σύνδεση σε εξέλιξη...',
    loginFailed: 'Η σύνδεση απέτυχε',
    email: 'Ηλ. ταχυδρομείο',
    password: 'Κωδικός πρόσβασης',
    username: 'Όνομα χρήστη',
    enterEmail: 'Εισαγάγετε τη διεύθυνση ηλ. ταχυδρομείου σας',
    enterPassword: 'Εισαγάγετε τον κωδικό πρόσβασής σας',
    enterUsername: 'Εισαγάγετε το όνομα χρήστη σας',
    forgotPassword: 'Ξεχάσατε τον κωδικό;',
    forgotPasswordTitle: 'Ξεχασμένος κωδικός',
    forgotPasswordDesc: 'Εισαγάγετε το όνομα χρήστη και τη διεύθυνση ηλ. ταχυδρομείου σας. Εάν ταιριάζουν, οι διαχειριστές θα ειδοποιηθούν για επαναφορά του κωδικού σας.',
    requestPasswordReset: 'Αίτημα επαναφοράς κωδικού',
    sending: 'Αποστολή...',
    backToLogin: 'Επιστροφή στη σύνδεση',
    pleaseWait: 'Παρακαλώ περιμένετε πριν δοκιμάσετε ξανά.',
    requestFailed: 'Το αίτημα απέτυχε',
    credentialsMatch: 'Εάν τα διαπιστευτήρια ταιριάζουν, οι διαχειριστές έχουν ειδοποιηθεί.',
    forAccess: 'Για πρόσβαση, επικοινωνήστε με τον διαχειριστή του συστήματος.',
    changePassword: 'Αλλαγή κωδικού',
    currentPassword: 'Τρέχων κωδικός',
    newPassword: 'Νέος κωδικός',
    confirmPassword: 'Επιβεβαίωση κωδικού',
    passwordChanged: 'Ο κωδικός αλλάχθηκε επιτυχώς',
    passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    passwordTooShort: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    changingPassword: 'Αλλαγή...',
    mustChangePassword: 'Πρέπει να αλλάξετε τον κωδικό σας πριν συνεχίσετε.',
    sessionExpiring: 'Η συνεδρία λήγει',
    sessionExpireText: 'Η συνεδρία σας θα λήξει σε <strong>{{time}}</strong>. Παρακαλώ αποθηκεύστε την εργασία σας και συνδεθείτε ξανά για να συνεχίσετε.',
    dismiss: 'Απόρριψη',
    switchNation: 'Αλλαγή χώρας',
    returnTo: 'Επιστροφή σε {{nation}}',
    viewingAs: 'Προβολή ως',
    loggedInAs: 'συνδεδεμένος ως {{nation}}',
    trainingMode: 'ΜΟΝΟ ΓΙΑ ΕΚΠΑΙΔΕΥΤΙΚΟΥΣ ΣΚΟΠΟΥΣ',
    dedication: 'Δημιουργήθηκε με αγάπη και αφοσίωση στο επάγγελμα',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Διαχειριστής συστήματος',
    excon: 'Ελεγκτής άσκησης',
    eu: 'Συντονιστής ΕΕ',
    planner: 'Σχεδιαστής',
    hub: 'Διαχειριστής κόμβου',
    nation: 'Χώρα',
    readOnly: 'Μόνο ανάγνωση',
    systemAdmin: 'Διαχειριστής συστήματος',
    transportPlanner: 'Σχεδιαστής μεταφορών',
    systemRoles: 'Ρόλοι συστήματος',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Πρόχειρο',
    underReview: 'Υπό εξέταση',
    published: 'Δημοσιευμένο',
    underSelection: 'Υπό επιλογή',
    accepted: 'Αποδεκτό',
    planned: 'Προγραμματισμένο',
    inTransit: 'Σε μεταφορά',
    completed: 'Ολοκληρωμένο',
    closed: 'Κλειστό',
    withdrawn: 'Αποσυρμένο',
    pending: 'Σε αναμονή',
    rejected: 'Απορρίφθηκε',
    cancelled: 'Ακυρώθηκε',
    active: 'Ενεργό',
    inactive: 'Ανενεργό',
    review: 'Εξέταση',
    selection: 'Επιλογή',
    transit: 'Μεταφορά',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Προσωπικό',
    material: 'Υλικό',
    equipment: 'Εξοπλισμός',
    other: 'Άλλο',
    news: 'Ειδήσεις',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Τακτικό',
    priority: 'Προτεραιότητα',
    urgent: 'Επείγον',
    immediate: 'Άμεσο',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Τρένο',
    ship: 'Πλοίο',
    aircraft: 'Αεροσκάφος',
    bus: 'Λεωφορείο',
    ambulance: 'Ασθενοφόρο',
    drone: 'Drone',
    helicopter: 'Ελικόπτερο',
    ferry: 'Πορθμείο',
    other: 'Άλλο',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Πίνακας ελέγχου',
    goodMorning: 'Καλημέρα',
    goodAfternoon: 'Καλό απόγευμα',
    goodEvening: 'Καλησπέρα',
    lastLogin: 'Τελευταία σύνδεση',
    infrastructure: 'Υποδομή',
    transportAssets: 'Μέσα μεταφοράς',
    treatmentFacilities: 'Μονάδες θεραπείας',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Στατιστικά αιτημάτων',
    viewAllRequests: 'Προβολή όλων των αιτημάτων',
    availableAssets: 'Διαθέσιμα μέσα',
    seated: 'Καθήμενοι',
    lying: 'Κατάκλιτοι',
    intensive: 'Εντατική',
    notifications: 'Ειδοποιήσεις',
    markAllRead: 'Σήμανση όλων ως αναγνωσμένα',
    noNotifications: 'Δεν υπάρχουν ειδοποιήσεις ακόμα',
    notifiedWhenActivity: 'Θα ειδοποιηθείτε όταν προκύψει νέα δραστηριότητα',
    viewDetailsBtn: 'Προβολή λεπτομερειών',
    nationUsers: 'Χρήστες χώρας',
    user: 'Χρήστης',
    roles: 'Ρόλοι',
    noUsersFound: 'Δεν βρέθηκαν χρήστες',
    participatingNations: 'Συμμετέχουσες χώρες',
    exerciseDisclaimer: 'Αυτό το σύστημα προορίζεται μόνο για χρήση σε ασκήσεις. Εισαγάγετε αποκλειστικά προσομοιωμένα δεδομένα άσκησης. Οι ροές εργασίας είναι προσαρμοσμένες στο σενάριο της άσκησης και ενδέχεται να διαφέρουν από τις πραγματικές διαδικασίες. Οι κανόνες ασφάλειας πληροφορικής και προστασίας δεδομένων εξακολουθούν να ισχύουν πλήρως.',
    notConfigured: 'Δεν έχει ρυθμιστεί',
    requestCount: '{{count}} αίτημα(τα)',
    clickToView: 'Κάντε κλικ για προβολή',
    systemAdministration: 'Διαχείριση συστήματος',
    exerciseControlTitle: 'Έλεγχος άσκησης',
    euCoordination: 'Συντονισμός ΕΕ',
    transportPlanningTitle: 'Σχεδιασμός μεταφορών',
    hubManagement: 'Διαχείριση κόμβων',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Νέο αίτημα',
    myDrafts: 'Τα πρόχειρά μου',
    pendingReview: 'Σε αναμονή εξέτασης',
    activeTransports: 'Ενεργές μεταφορές',
    myPatients: 'Οι ασθενείς μου',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Αιτήματα',
    newRequest: 'Νέο αίτημα',
    createRequest: 'Δημιουργία αιτήματος',
    editRequest: 'Επεξεργασία αιτήματος',
    requestDetail: 'Λεπτομέρειες αιτήματος',
    requestId: 'Αναγνωριστικό αιτήματος',
    fromNation: 'Από χώρα',
    toNation: 'Προς χώρα',
    requestingNation: 'Αιτούσα χώρα',
    receivingNation: 'Χώρα υποδοχής',
    category: 'Κατηγορία',
    urgency: 'Επείγον',
    status: 'Κατάσταση',
    patients: 'Ασθενείς',
    patientCount: 'Αριθμός ασθενών',
    offers: 'Προσφορές',
    offerCount: 'Αριθμός προσφορών',
    created: 'Δημιουργήθηκε',
    updated: 'Ενημερώθηκε',
    submittedBy: 'Υποβλήθηκε από',
    reviewedBy: 'Εξετάστηκε από',
    description: 'Περιγραφή',
    medicalDetails: 'Ιατρικές λεπτομέρειες',
    transportDetails: 'Λεπτομέρειες μεταφοράς',
    additionalInfo: 'Πρόσθετες πληροφορίες',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Σημείο αναχώρησης',
    arrivalPoint: 'Σημείο άφιξης',
    estimatedDeparture: 'Εκτιμώμενη αναχώρηση',
    estimatedArrival: 'Εκτιμώμενη άφιξη',
    submitForReview: 'Υποβολή για εξέταση',
    publish: 'Δημοσίευση',
    startSelection: 'Έναρξη επιλογής',
    acceptOffer: 'Αποδοχή προσφοράς',
    markInTransit: 'Σήμανση σε μεταφορά',
    markCompleted: 'Σήμανση ολοκληρωμένου',
    closeRequest: 'Κλείσιμο αιτήματος',
    withdrawRequest: 'Απόσυρση αιτήματος',
    withdraw: 'Απόσυρση',
    revertToDraft: 'Επαναφορά σε πρόχειρο',
    deleteRequest: 'Διαγραφή αιτήματος',
    duplicateRequest: 'Αντιγραφή αιτήματος',
    createFollowUp: 'Δημιουργία ενοποιημένου αιτήματος',
    followUpRequest: 'Ενοποιημένο αίτημα',
    parentRequest: 'Αρχικό αίτημα',
    childRequests: 'Ενοποιημένα αιτήματα',
    noRequests: 'Δεν βρέθηκαν αιτήματα',
    noOffers: 'Δεν υπάρχουν προσφορές ακόμα',
    addPatient: 'Προσθήκη ασθενούς',
    removePatient: 'Αφαίρεση ασθενούς',
    patientDetails: 'Στοιχεία ασθενούς',
    contactPerson: 'Υπεύθυνος επικοινωνίας',
    contactPhone: 'Τηλέφωνο επικοινωνίας',
    contactEmail: 'Email επικοινωνίας',
    specialRequirements: 'Ειδικές απαιτήσεις',
    medicalEquipment: 'Ιατρικός εξοπλισμός',
    accompaniment: 'Συνοδεία',
    timeline: 'Χρονοδιάγραμμα',
    history: 'Ιστορικό',
    addComment: 'Προσθήκη σχολίου',
    writeComment: 'Γράψτε ένα σχόλιο...',
    postComment: 'Δημοσίευση σχολίου',
    posting: 'Δημοσίευση...',
    noComments: 'Δεν υπάρχουν σχόλια ακόμα',
    coverageBar: 'Κάλυψη',
    covered: 'καλυμμένο',
    uncovered: 'ακάλυπτο',
    filterByStatus: 'Φίλτρο κατά κατάσταση',
    filterByCategory: 'Φίλτρο κατά κατηγορία',
    filterByNation: 'Φίλτρο κατά χώρα',
    searchRequests: 'Αναζήτηση αιτημάτων...',
    confirmWithdraw: 'Είστε βέβαιοι ότι θέλετε να αποσύρετε αυτό το αίτημα;',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το αίτημα;',
    confirmPublish: 'Είστε βέβαιοι ότι θέλετε να δημοσιεύσετε αυτό το αίτημα; Θα είναι ορατό σε όλες τις χώρες.',
    confirmStartSelection: 'Είστε βέβαιοι ότι θέλετε να ξεκινήσετε την επιλογή; Οι χώρες θα μπορούν να υποβάλουν προσφορές.',
    warningStartSelection: 'Η έναρξη της επιλογής θα κάνει αυτό το αίτημα ορατό σε όλες τις συμμετέχουσες χώρες. Θα μπορούν να υποβάλουν προσφορές για τους ασθενείς αυτού του αιτήματος. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    warningMakeOffer: 'Υποβάλλοντας αυτή την προσφορά, δεσμεύετε τη χώρα σας να παρέχει την προτεινόμενη βοήθεια. Αυτή η ενέργεια θα ειδοποιήσει την αιτούσα χώρα και τον έλεγχο άσκησης.',
    saveDraft: 'Αποθήκευση πρόχειρου',
    saving: 'Αποθήκευση...',
    saveAndSubmit: 'Αποθήκευση και υποβολή',
    step: 'Βήμα {{number}}',
    generalInfo: 'Γενικές πληροφορίες',
    patientInfo: 'Πληροφορίες ασθενούς',
    logisticsInfo: 'Πληροφορίες εφοδιαστικής',
    reviewSubmit: 'Εξέταση και υποβολή',
    requestTitle: 'Τίτλος αιτήματος',
    requestDescription: 'Περιγραφή αιτήματος',
    numberOfPatients: 'Αριθμός ασθενών',
    typeOfAssistance: 'Τύπος βοήθειας',
    medicalTreatment: 'Ιατρική θεραπεία',
    transportAssistance: 'Βοήθεια μεταφοράς',
    both: 'Και τα δύο',
    treatmentOnly: 'Μόνο θεραπεία',
    transportOnly: 'Μόνο μεταφορά',
    validationErrors: 'Παρακαλώ διορθώστε τα ακόλουθα σφάλματα:',
    fieldRequired: 'Αυτό το πεδίο είναι υποχρεωτικό',
    selectExitHub: 'Επιλέξτε κόμβο εξόδου',
    createExitHub: 'Δημιουργία κόμβου εξόδου',
    backToRequests: 'Επιστροφή στα αιτήματα',
    noRequestsFound: 'Δεν βρέθηκαν αιτήματα',
    createFirstRequest: 'Δημιουργήστε το πρώτο σας αίτημα για να ξεκινήσετε',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Προσφορές',
    createOffer: 'Δημιουργία προσφοράς',
    makeOffer: 'Υποβολή προσφοράς',
    manageOffers: 'Διαχείριση προσφορών',
    offerDetail: 'Λεπτομέρειες προσφοράς',
    offerId: 'Αναγνωριστικό προσφοράς',
    offeringNation: 'Χώρα προσφοράς',
    offerType: 'Τύπος προσφοράς',
    treatment: 'Θεραπεία',
    transport: 'Μεταφορά',
    combined: 'Συνδυασμένη',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Προσφορά θεραπείας',
    transportOffer: 'Προσφορά μεταφοράς',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Επιλογή ασθενών',
    selectedPatients: 'Επιλεγμένοι ασθενείς',
    patientSelection: 'Επιλογή ασθενών',
    offerConfiguration: 'Ρύθμιση προσφοράς',
    reviewOffer: 'Εξέταση προσφοράς',
    submitOffer: 'Υποβολή προσφοράς',
    submitting: 'Υποβολή...',
    acceptOffer: 'Αποδοχή προσφοράς',
    rejectOffer: 'Απόρριψη προσφοράς',
    withdrawOffer: 'Απόσυρση προσφοράς',
    noOffers: 'Δεν υπάρχουν διαθέσιμες προσφορές',
    noOffer: 'No Offer',
    offerStatus: 'Κατάσταση προσφοράς',
    offerDate: 'Ημερομηνία προσφοράς',
    transportAsset: 'Μέσο μεταφοράς',
    departureDate: 'Ημερομηνία αναχώρησης',
    arrivalDate: 'Ημερομηνία άφιξης',
    treatmentFacility: 'Μονάδα θεραπείας',
    capacity: 'Χωρητικότητα',
    availableCapacity: 'Διαθέσιμη χωρητικότητα',
    totalCapacity: 'Συνολική χωρητικότητα',
    selectAsset: 'Επιλογή μέσου',
    selectFacility: 'Επιλογή μονάδας',
    offerNotes: 'Σημειώσεις προσφοράς',
    confirmAccept: 'Είστε βέβαιοι ότι θέλετε να αποδεχτείτε αυτή την προσφορά;',
    confirmReject: 'Είστε βέβαιοι ότι θέλετε να απορρίψετε αυτή την προσφορά;',
    extendTransport: 'Επέκταση μεταφοράς',
    transportExtension: 'Επέκταση μεταφοράς',
    comparisonView: 'Προβολή σύγκρισης',
    shortlist: 'Λίστα επιλεγμένων',
    addToShortlist: 'Προσθήκη στη λίστα επιλεγμένων',
    removeFromShortlist: 'Αφαίρεση από τη λίστα επιλεγμένων',
    leaveConfirmTitle: 'Αποχώρηση από τη σελίδα;',
    leaveConfirmMessage: 'Έχετε μη αποθηκευμένες αλλαγές. Είστε βέβαιοι ότι θέλετε να φύγετε;',
    stayOnPage: 'Παραμονή στη σελίδα',
    leavePage: 'Αποχώρηση',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Μεταφορές',
    missionDetail: 'Λεπτομέρειες μεταφοράς',
    missionId: 'Αναγνωριστικό μεταφοράς',
    missionStatus: 'Κατάσταση μεταφοράς',
    createMission: 'Δημιουργία μεταφοράς',
    overview: 'Επισκόπηση',
    patientsTab: 'Ασθενείς',
    transportsTab: 'Σκέλη μεταφοράς',
    treatmentTab: 'Θεραπεία',
    reviewTab: 'Εξέταση',
    departure: 'Αναχώρηση',
    arrival: 'Άφιξη',
    origin: 'Προέλευση',
    destination: 'Προορισμός',
    stops: 'Στάσεις',
    addStop: 'Προσθήκη στάσης',
    removeStop: 'Αφαίρεση στάσης',
    stopName: 'Όνομα στάσης',
    stopType: 'Τύπος στάσης',
    estimatedTime: 'Εκτιμώμενη ώρα',
    actualTime: 'Πραγματική ώρα',
    asset: 'Μέσο',
    driver: 'Οδηγός',
    crew: 'Πλήρωμα',
    noMissions: 'Δεν βρέθηκαν μεταφορές',
    completeMission: 'Ολοκλήρωση μεταφοράς',
    cancelMission: 'Ακύρωση μεταφοράς',
    startTransport: 'Έναρξη μεταφοράς',
    missionChain: 'Αλυσίδα μεταφοράς',
    linkedMissions: 'Συνδεδεμένες μεταφορές',
    handover: 'Παράδοση',
    handoverPoint: 'Σημείο παράδοσης',
    pickupPoint: 'Σημείο παραλαβής',
    dropoffPoint: 'Σημείο αποβίβασης',
    searchTransports: 'Αναζήτηση μεταφορών...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Ασθενείς',
    myPatients: 'Οι ασθενείς μου',
    patientId: 'Αναγνωριστικό ασθενούς',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    dateOfBirth: 'Ημερομηνία γέννησης',
    age: 'Ηλικία',
    gender: 'Φύλο',
    male: 'Άνδρας',
    female: 'Γυναίκα',
    other: 'Άλλο',
    nationality: 'Εθνικότητα',
    diagnosis: 'Διάγνωση',
    condition: 'Κατάσταση',
    stable: 'Σταθερή',
    critical: 'Κρίσιμη',
    serious: 'Σοβαρή',
    treatmentNeeded: 'Απαιτείται θεραπεία',
    allergies: 'Αλλεργίες',
    medications: 'Φάρμακα',
    bloodType: 'Ομάδα αίματος',
    weight: 'Βάρος (kg)',
    infectious: 'Μολυσματικό',
    mentalHealth: 'Ψυχική υγεία',
    mobility: 'Κινητικότητα',
    ambulatory: 'Βαδίζων',
    wheelchair: 'Αναπηρικό αμαξίδιο',
    stretcher: 'Φορείο',
    intensive: 'Εντατική φροντίδα',
    oxygenRequired: 'Απαιτείται οξυγόνο',
    ventilator: 'Αναπνευστήρας',
    medicalEscort: 'Ιατρική συνοδεία',
    noPatients: 'Δεν βρέθηκαν ασθενείς',
    patientDetails: 'Στοιχεία ασθενούς',
    medicalHistory: 'Ιατρικό ιστορικό',
    travelDocuments: 'Ταξιδιωτικά έγγραφα',
    passport: 'Διαβατήριο',
    pseudonymizedId: 'Ψευδωνυμοποιημένο αναγνωριστικό',
    sensitiveData: 'Ευαίσθητα δεδομένα',
    journey: 'Διαδρομή ασθενούς',
    assignedTo: 'Ανατέθηκε σε',
    currentLocation: 'Τρέχουσα τοποθεσία',
    importPatients: 'Εισαγωγή ασθενών',
    exportPatients: 'Εξαγωγή ασθενών',
    seated: 'Καθήμενοι',
    lying: 'Κατάκλιτοι',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Χρήστες',
    createUser: 'Δημιουργία χρήστη',
    editUser: 'Επεξεργασία χρήστη',
    deleteUser: 'Διαγραφή χρήστη',
    username: 'Όνομα χρήστη',
    displayName: 'Εμφανιζόμενο όνομα',
    email: 'Ηλ. ταχυδρομείο',
    password: 'Κωδικός πρόσβασης',
    role: 'Ρόλος',
    roles: 'Ρόλοι',
    nation: 'Χώρα',
    active: 'Ενεργός',
    lastLogin: 'Τελευταία σύνδεση',
    createdAt: 'Δημιουργήθηκε',
    isNation: 'Χώρα',
    isEU: 'ΕΕ',
    isAdmin: 'Διαχειριστής',
    isExcon: 'EXCON',
    isPlanner: 'Σχεδιαστής',
    isHub: 'Κόμβος',
    isReadOnly: 'Μόνο ανάγνωση',
    noUsers: 'Δεν βρέθηκαν χρήστες',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον χρήστη;',
    resetPassword: 'Επαναφορά κωδικού',
    generatePassword: 'Δημιουργία κωδικού',
    searchUsers: 'Αναζήτηση χρηστών...',
    userCreated: 'Ο χρήστης δημιουργήθηκε επιτυχώς',
    userUpdated: 'Ο χρήστης ενημερώθηκε επιτυχώς',
    userDeleted: 'Ο χρήστης διαγράφηκε επιτυχώς',
    selectNation: 'Επιλέξτε χώρα',
    mustChangePassword: 'Πρέπει να αλλάξει κωδικό στην επόμενη σύνδεση',
    flagImage: 'Εικόνα σημαίας',
    exportUsers: 'Εξαγωγή χρηστών',
    importUsers: 'Εισαγωγή χρηστών',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Μέσα',
    createAsset: 'Δημιουργία μέσου',
    editAsset: 'Επεξεργασία μέσου',
    deleteAsset: 'Διαγραφή μέσου',
    assetName: 'Όνομα μέσου',
    assetType: 'Τύπος μέσου',
    capacitySeated: 'Χωρητικότητα (καθήμενοι)',
    capacityLying: 'Χωρητικότητα (κατάκλιτοι)',
    capacityIntensive: 'Χωρητικότητα (εντατική)',
    owner: 'Ιδιοκτήτης',
    operator: 'Φορέας εκμετάλλευσης',
    baseLocation: 'Βάση',
    range: 'Εμβέλεια',
    speed: 'Ταχύτητα',
    noAssets: 'Δεν βρέθηκαν μέσα',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το μέσο;',
    searchAssets: 'Αναζήτηση μέσων...',
    assetCreated: 'Το μέσο δημιουργήθηκε επιτυχώς',
    assetUpdated: 'Το μέσο ενημερώθηκε επιτυχώς',
    assetDeleted: 'Το μέσο διαγράφηκε επιτυχώς',
    exportAssets: 'Εξαγωγή μέσων',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Κόμβοι',
    startPoints: 'Σημεία εκκίνησης',
    createHub: 'Δημιουργία κόμβου',
    editHub: 'Επεξεργασία κόμβου',
    deleteHub: 'Διαγραφή κόμβου',
    hubName: 'Όνομα κόμβου',
    hubType: 'Τύπος κόμβου',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Κόμβος εισόδου',
    airport: 'Αεροδρόμιο',
    seaport: 'Λιμάνι',
    railStation: 'Σιδηροδρομικός σταθμός',
    roadPoint: 'Οδικό σημείο',
    ucpmClassification: 'Ταξινόμηση UCPM',
    icaoCode: 'Κωδικός ICAO',
    iataCode: 'Κωδικός IATA',
    noHubs: 'Δεν βρέθηκαν κόμβοι',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον κόμβο;',
    searchHubs: 'Αναζήτηση κόμβων...',
    nationAssignment: 'Ανάθεση χωρών',
    assignNations: 'Ανάθεση χωρών',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Μονάδες θεραπείας',
    createFacility: 'Δημιουργία μονάδας',
    editFacility: 'Επεξεργασία μονάδας',
    deleteFacility: 'Διαγραφή μονάδας',
    facilityName: 'Όνομα μονάδας',
    facilityType: 'Τύπος μονάδας',
    hospitalName: 'Όνομα νοσοκομείου',
    bedCapacity: 'Χωρητικότητα κλινών',
    specialties: 'Ειδικότητες',
    availableBeds: 'Διαθέσιμες κλίνες',
    totalBeds: 'Συνολικές κλίνες',
    contactPerson: 'Υπεύθυνος επικοινωνίας',
    noFacilities: 'Δεν βρέθηκαν μονάδες θεραπείας',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή τη μονάδα;',
    searchFacilities: 'Αναζήτηση μονάδων...',
    hubNationAssignment: 'Ανάθεση κόμβου-χώρας',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Δρομολόγια',
    createSchedule: 'Δημιουργία δρομολογίου',
    editSchedule: 'Επεξεργασία δρομολογίου',
    deleteSchedule: 'Διαγραφή δρομολογίου',
    scheduleName: 'Όνομα δρομολογίου',
    scheduleType: 'Τύπος δρομολογίου',
    recurring: 'Επαναλαμβανόμενο',
    oneTime: 'Εφάπαξ',
    frequency: 'Συχνότητα',
    daily: 'Ημερήσιο',
    weekly: 'Εβδομαδιαίο',
    startDate: 'Ημερομηνία έναρξης',
    endDate: 'Ημερομηνία λήξης',
    departureTime: 'Ώρα αναχώρησης',
    arrivalTime: 'Ώρα άφιξης',
    stops: 'Στάσεις',
    addStop: 'Προσθήκη στάσης',
    noSchedules: 'Δεν βρέθηκαν δρομολόγια',
    bookings: 'Κρατήσεις',
    timeline: 'Χρονοδιάγραμμα',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Ειδοποιήσεις',
    markAllRead: 'Σήμανση όλων ως αναγνωσμένα',
    markAsRead: 'Σήμανση ως αναγνωσμένο',
    markAsUnread: 'Σήμανση ως μη αναγνωσμένο',
    noNotifications: 'Δεν υπάρχουν ειδοποιήσεις',
    viewAll: 'Προβολή όλων των ειδοποιήσεων',
    settings: 'Ρυθμίσεις ειδοποιήσεων',
    emailNotifications: 'Ειδοποιήσεις ηλ. ταχυδρομείου',
    inAppNotifications: 'Ειδοποιήσεις εφαρμογής',
    notifyOn: 'Ειδοποίηση για',
    requestCreated: 'Νέο αίτημα',
    requestPublished: 'Αίτημα δημοσιεύτηκε',
    requestClosed: 'Αίτημα έκλεισε',
    requestCompleted: 'Αίτημα ολοκληρώθηκε',
    commentAdded: 'Νέο σχόλιο',
    offerReceived: 'Προσφορά ελήφθη',
    offerAccepted: 'Προσφορά έγινε αποδεκτή',
    statusChanged: 'Αλλαγή κατάστασης',
    selectionStarted: 'Έναρξη επιλογής',
    missionCreated: 'Μεταφορά δημιουργήθηκε',
    missionStatusUpdated: 'Μεταφορά ενημερώθηκε',
    transportPartnerNamed: 'Εταίρος μεταφοράς',
    transportExtensionReceived: 'Επέκταση μεταφοράς',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Ρυθμίσεις',
    general: 'Γενικά',
    system: 'Σύστημα',
    email: 'Ηλ. ταχυδρομείο',
    sync: 'Συγχρονισμός',
    security: 'Ασφάλεια',
    appearance: 'Εμφάνιση',
    systemName: 'Όνομα συστήματος',
    systemEmail: 'Email συστήματος',
    maintenanceMode: 'Λειτουργία συντήρησης',
    readOnlyMode: 'Λειτουργία μόνο ανάγνωσης',
    emailEnabled: 'Email ενεργοποιημένο',
    smtpHost: 'Διακομιστής SMTP',
    smtpPort: 'Θύρα SMTP',
    smtpUser: 'Χρήστης SMTP',
    smtpPassword: 'Κωδικός SMTP',
    senderEmail: 'Email αποστολέα',
    senderName: 'Όνομα αποστολέα',
    testEmail: 'Αποστολή δοκιμαστικού email',
    syncEnabled: 'Συγχρονισμός ενεργοποιημένος',
    syncUrl: 'URL συγχρονισμού',
    syncApiKey: 'Κλειδί API συγχρονισμού',
    settingsSaved: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς',
    helpdesk: 'Γραφείο υποστήριξης',
    helpdeskTitle: 'Τίτλος γραφείου υποστήριξης',
    helpdeskEmail: 'Email γραφείου υποστήριξης',
    helpdeskPhone: 'Τηλέφωνο γραφείου υποστήριξης',
    helpdeskInfo: 'Πληροφορίες γραφείου υποστήριξης',
    realLifeSupport: 'Υποστήριξη πραγματικών καταστάσεων',
    trainingMode: 'Λειτουργία εκπαίδευσης',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Αρχεία ελέγχου',
    action: 'Ενέργεια',
    user: 'Χρήστης',
    target: 'Στόχος',
    details: 'Λεπτομέρειες',
    timestamp: 'Χρονοσήμανση',
    ipAddress: 'Διεύθυνση IP',
    noLogs: 'Δεν βρέθηκαν αρχεία ελέγχου',
    searchLogs: 'Αναζήτηση αρχείων...',
    filterByAction: 'Φίλτρο κατά ενέργεια',
    filterByUser: 'Φίλτρο κατά χρήστη',
    exportLogs: 'Εξαγωγή αρχείων',
    exportCsv: 'Εξαγωγή CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Έλεγχος άσκησης',
    currentDay: 'Τρέχουσα ημέρα',
    exerciseDay: 'Ημέρα άσκησης',
    nextDay: 'Επόμενη ημέρα',
    previousDay: 'Προηγούμενη ημέρα',
    resetExercise: 'Επαναφορά άσκησης',
    startExercise: 'Έναρξη άσκησης',
    endExercise: 'Λήξη άσκησης',
    dayReset: 'Επαναφορά ημέρας',
    confirmReset: 'Είστε βέβαιοι ότι θέλετε να επαναφέρετε την ημέρα άσκησης; Αυτό θα διαγράψει όλα τα δεδομένα της τρέχουσας ημέρας.',
    resetInProgress: 'Επαναφορά σε εξέλιξη...',
    maintenanceMode: 'Λειτουργία συντήρησης',
    enableMaintenance: 'Ενεργοποίηση συντήρησης',
    disableMaintenance: 'Απενεργοποίηση συντήρησης',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Συγχρονισμός δεδομένων',
    syncStatus: 'Κατάσταση συγχρονισμού',
    lastSync: 'Τελευταίος συγχρονισμός',
    pendingItems: 'Εκκρεμή στοιχεία',
    syncNow: 'Συγχρονισμός τώρα',
    syncing: 'Συγχρονισμός...',
    syncSuccess: 'Ο συγχρονισμός ολοκληρώθηκε επιτυχώς',
    syncFailed: 'Ο συγχρονισμός απέτυχε',
    outbox: 'Εξερχόμενα',
    inbox: 'Εισερχόμενα',
    configuration: 'Ρύθμιση',
    targetUrl: 'URL προορισμού',
    apiKey: 'Κλειδί API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Χάρτης',
    layers: 'Επίπεδα',
    requests: 'Αιτήματα',
    hubs: 'Κόμβοι',
    facilities: 'Μονάδες',
    routes: 'Διαδρομές',
    showAll: 'Εμφάνιση όλων',
    hideAll: 'Απόκρυψη όλων',
    zoomIn: 'Μεγέθυνση',
    zoomOut: 'Σμίκρυνση',
    resetView: 'Επαναφορά προβολής',
    satellite: 'Δορυφορική',
    terrain: 'Ανάγλυφο',
    offline: 'Εκτός σύνδεσης',
    online: 'Σε σύνδεση',
    tilesOffline: 'Τα πλακίδια χάρτη εξυπηρετούνται τοπικά',
    tilesOnline: 'Τα πλακίδια χάρτη φορτώνονται από διακομιστές',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Στατιστικά',
    overview: 'Επισκόπηση',
    requestsByStatus: 'Αιτήματα ανά κατάσταση',
    requestsByCategory: 'Αιτήματα ανά κατηγορία',
    requestsByNation: 'Αιτήματα ανά χώρα',
    offersByStatus: 'Προσφορές ανά κατάσταση',
    patientsByCondition: 'Ασθενείς ανά κατάσταση',
    transportsByStatus: 'Μεταφορές ανά κατάσταση',
    timeline: 'Χρονοδιάγραμμα',
    totalRequests: 'Σύνολο αιτημάτων',
    totalOffers: 'Σύνολο προσφορών',
    totalPatients: 'Σύνολο ασθενών',
    totalTransports: 'Σύνολο μεταφορών',
    averageResponseTime: 'Μέσος χρόνος απόκρισης',
    completionRate: 'Ποσοστό ολοκλήρωσης',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Στατιστικά άσκησης',
    overview: 'Επισκόπηση',
    byCategory: 'Ανά κατηγορία',
    byNation: 'Ανά χώρα',
    byDay: 'Ανά ημέρα',
    totalPatientsMoved: 'Σύνολο μεταφερθέντων ασθενών',
    totalRequestsProcessed: 'Σύνολο επεξεργασμένων αιτημάτων',
    averageProcessingTime: 'Μέσος χρόνος επεξεργασίας',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Διάγραμμα ροής',
    sankey: 'Sankey',
    nodeGraph: 'Γράφος κόμβων',
    refresh: 'Ανανέωση',
    noData: 'Δεν υπάρχουν διαθέσιμα δεδομένα ροής',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Σχετικά',
    version: 'Έκδοση',
    systemInfo: 'Πληροφορίες συστήματος',
    buildDate: 'Ημερομηνία κατασκευής',
    environment: 'Περιβάλλον',
    description: 'ARCOS — Προηγμένο Σύστημα Επικοινωνίας Αιτημάτων',
    subtitle: 'Βοήθεια Θυμάτων και Ιατρικές Επιχειρήσεις',
    whatIsArcos: 'Τι είναι το ARCOS; – Εξήγηση για τους συμμετέχοντες στην άσκηση',
    arcosDesc1: 'Το ARCOS είναι ένα ψηφιακό εργαλείο που χρησιμοποιείται σε αυτήν την άσκηση για την υποστήριξη και δόμηση της διεθνούς επικοινωνίας, των αιτημάτων και των διαδικασιών συντονισμού.',
    arcosDesc2: 'Το ARCOS παρέχει μια απλοποιημένη αναπαράσταση των βασικών αρχών αυτών των συστημάτων.',
    arcosUsedFor: 'Κατά τη διάρκεια της άσκησης, το ARCOS χρησιμοποιείται για:',
    arcosUsedForItem1: 'υποβολή και διαχείριση αιτημάτων βοήθειας,',
    arcosUsedForItem2: 'συντονισμό και ανταπόκριση σε προσφορές υποστήριξης,',
    arcosUsedForItem3: 'παρακολούθηση κατάστασης και προόδου αιτημάτων,',
    arcosUsedForItem4: 'και αναπαράσταση απλοποιημένων ροών μεταφοράς ή εκκένωσης.',
    arcosDesc3: 'Οι ροές εργασίας στο ARCOS είναι σκόπιμα απλοποιημένες.',
    arcosDesc4: 'Ο στόχος του ARCOS δεν είναι η προσομοίωση ενός τέλειου πραγματικού συστήματος.',
    arcosDesc5: 'Αν ορισμένα στοιχεία διαφέρουν από πραγματικές διαδικασίες, αυτό είναι αναμενόμενο.',
    facilitatedBy: 'Υποστηρίζεται από το MMCC-E',
    dhcInitiative: 'Το Digital Health Corner (DHC) είναι κοινή πρωτοβουλία:',
    dhcAuthor1: 'Sven Giegerich — Γερμανικές Ένοπλες Δυνάμεις',
    dhcAuthor2: 'Mohamad Haji — Βελγική Άμυνα',
    dhcConviction: 'Γεννημένο από την πεποίθηση ότι η καινοτομία ανθεί εκεί που το πάθος συναντά τον πραγματισμό.',
    dhcInspired: 'Εμπνευσμένοι από τη σπίθα του MMCC-E, ξεκινήσαμε να δημιουργήσουμε απλές αλλά αποτελεσματικές λύσεις.',
    dhcLove: 'Το κάνουμε γιατί αγαπάμε τη δουλειά μας.',
    dhcOpen: 'Το DHC είναι μια ανοιχτή πλατφόρμα: χωρίς ιεραρχίες, ανοιχτή σε ιδέες.',
    dhcClosing: 'Digital Health Corner – όπου η περιέργεια συναντά τη συνεργασία.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Τεκμηρίωση',
    gettingStarted: 'Ξεκινώντας',
    userGuide: 'Οδηγός χρήστη',
    faq: 'Συχνές ερωτήσεις',
    troubleshooting: 'Αντιμετώπιση προβλημάτων',
    apiReference: 'Αναφορά API',
    downloadTemplate: 'Λήψη προτύπου',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Εισαγωγή ασθενών',
    uploadFile: 'Μεταφόρτωση αρχείου',
    selectFile: 'Επιλογή αρχείου',
    preview: 'Προεπισκόπηση',
    importNow: 'Εισαγωγή τώρα',
    importing: 'Εισαγωγή...',
    importSuccess: '{{count}} ασθενείς εισήχθησαν επιτυχώς',
    importFailed: 'Η εισαγωγή απέτυχε',
    downloadTemplate: 'Λήψη προτύπου',
    dragDrop: 'Σύρετε και αποθέστε ένα αρχείο εδώ ή κάντε κλικ για επιλογή',
    supportedFormats: 'Υποστηριζόμενες μορφές: XLSX, XLS, CSV',
    rowsFound: '{{count}} γραμμές βρέθηκαν',
    validRows: '{{count}} έγκυρες γραμμές',
    invalidRows: '{{count}} μη έγκυρες γραμμές',
    duplicateRows: '{{count}} διπλότυπες γραμμές',
    previewData: 'Προεπισκόπηση δεδομένων',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Σχεδιασμός μεταφορών',
    planRoute: 'Σχεδιασμός διαδρομής',
    routeBuilder: 'Δημιουργός διαδρομής',
    addWaypoint: 'Προσθήκη σημείου διαδρομής',
    removeWaypoint: 'Αφαίρεση σημείου διαδρομής',
    estimatedDuration: 'Εκτιμώμενη διάρκεια',
    distance: 'Απόσταση',
    selectVehicle: 'Επιλογή οχήματος',
  },

  transportBooking: {
    title: 'Κράτηση μεταφοράς',
    bookTransport: 'Κράτηση μεταφοράς',
    availableSlots: 'Διαθέσιμες θέσεις',
    bookingConfirmed: 'Η κράτηση επιβεβαιώθηκε',
    cancelBooking: 'Ακύρωση κράτησης',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Σχεδιασμός χωρητικότητας',
    totalCapacity: 'Συνολική χωρητικότητα',
    usedCapacity: 'Χρησιμοποιούμενη χωρητικότητα',
    availableCapacity: 'Διαθέσιμη χωρητικότητα',
    utilizationRate: 'Ποσοστό αξιοποίησης',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Πρότυπα μέσων',
    dayTemplates: 'Πρότυπα ημέρας',
    createTemplate: 'Δημιουργία προτύπου',
    editTemplate: 'Επεξεργασία προτύπου',
    deleteTemplate: 'Διαγραφή προτύπου',
    templateName: 'Όνομα προτύπου',
    applyTemplate: 'Εφαρμογή προτύπου',
    noTemplates: 'Δεν βρέθηκαν πρότυπα',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πρότυπο;',
    confirmApply: 'Είστε βέβαιοι ότι θέλετε να εφαρμόσετε αυτό το πρότυπο; Τα υπάρχοντα δεδομένα θα αντικατασταθούν.',
    exportTemplates: 'Εξαγωγή προτύπων',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Ταινία ανακοινώσεων',
    createAnnouncement: 'Δημιουργία ανακοίνωσης',
    editAnnouncement: 'Επεξεργασία ανακοίνωσης',
    deleteAnnouncement: 'Διαγραφή ανακοίνωσης',
    message: 'Μήνυμα',
    startTime: 'Ώρα έναρξης',
    endTime: 'Ώρα λήξης',
    active: 'Ενεργή',
    noAnnouncements: 'Δεν υπάρχουν ανακοινώσεις',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή την ανακοίνωση;',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Αναζήτηση...',
      noResults: 'Δεν βρέθηκαν αποτελέσματα',
      showing: 'Εμφάνιση {{from}} έως {{to}} από {{total}}',
      rowsPerPage: 'Γραμμές ανά σελίδα',
      previousPage: 'Προηγούμενη σελίδα',
      nextPage: 'Επόμενη σελίδα',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Επιβεβαίωση',
      cancel: 'Ακύρωση',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Μη αποθηκευμένες αλλαγές',
      message: 'Έχετε μη αποθηκευμένες αλλαγές. Είστε βέβαιοι ότι θέλετε να φύγετε από αυτή τη σελίδα;',
      stay: 'Παραμονή στη σελίδα',
      leave: 'Αποχώρηση',
    },
    // EmptyState
    emptyState: {
      noData: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Κάτι πήγε στραβά',
      message: 'Παρουσιάστηκε μη αναμενόμενο σφάλμα. Παρακαλώ δοκιμάστε να ανανεώσετε τη σελίδα.',
      retry: 'Επανάληψη',
    },
    // ExportButton
    exportButton: {
      export: 'Εξαγωγή',
      exporting: 'Εξαγωγή...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Εκτύπωση',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Πρόχειρο',
      review: 'Εξέταση',
      published: 'Δημοσιευμένο',
      selection: 'Επιλογή',
      inTransit: 'Σε μεταφορά',
      completed: 'Ολοκληρωμένο',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Διαδικτυακό αντίγραφο',
      message: 'Λειτουργία μόνο ανάγνωσης. Τα δεδομένα συγχρονίζονται από τον κύριο διακομιστή.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Προβολή ως',
      loggedInAs: 'συνδεδεμένος ως {{nation}}',
      returnTo: 'Επιστροφή σε {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Αναζήτηση σελίδων, αιτημάτων, μεταφορών...',
      searching: 'Αναζήτηση...',
      noResults: 'Δεν βρέθηκαν αποτελέσματα για "{{query}}"',
      navigate: 'Πλοήγηση',
      select: 'Επιλογή',
      close: 'Κλείσιμο',
      pages: {
        dashboard: 'Πίνακας ελέγχου',
        requests: 'Αιτήματα',
        transports: 'Μεταφορές',
        map: 'Χάρτης',
        myPatients: 'Οι ασθενείς μου',
        flowDiagram: 'Διάγραμμα ροής',
        statistics: 'Στατιστικά',
        assets: 'Μέσα',
        startPoints: 'Σημεία εκκίνησης / Κόμβοι',
        treatmentFacilities: 'Μονάδες θεραπείας',
        users: 'Χρήστες',
        settings: 'Ρυθμίσεις',
        auditLogs: 'Αρχεία ελέγχου',
        exerciseControl: 'Έλεγχος άσκησης',
        dataSync: 'Συγχρονισμός δεδομένων',
        patientImport: 'Εισαγωγή ασθενών',
        notifications: 'Ειδοποιήσεις',
        documentation: 'Τεκμηρίωση',
      },
      actions: {
        importPatientsJson: 'Εισαγωγή Ασθενών (JSON)',
        importPatientsExcel: 'Εισαγωγή Ασθενών (Excel)',
        importUsers: 'Εισαγωγή Χρηστών (Excel)',
        importAssetTemplates: 'Εισαγωγή Προτύπων Πόρων (Excel)',
        importDayTemplates: 'Εισαγωγή Καταχωρήσεων Ημερήσιου Προτύπου (Excel)',
        exportRequests: 'Εξαγωγή Αιτημάτων (Excel)',
        exportPatients: 'Εξαγωγή Ασθενών (Excel)',
        exportUsers: 'Εξαγωγή Χρηστών (Excel)',
        exportCredentials: 'Εξαγωγή Διαπιστευτήρια (PDF)',
        exportAuditExcel: 'Εξαγωγή Αρχείο ελέγχου (Excel)',
        exportAuditPdf: 'Εξαγωγή Αρχείο ελέγχου (PDF)',
        pagePatientImport: 'Σελίδα εισαγωγής ασθενών',
        pageRequestDetail: 'Σελίδα λεπτομερειών αιτήματος',
        pageUsers: 'Σελίδα διαχείρισης χρηστών',
        pageAssetTemplates: 'Σελίδα προτύπων πόρων',
        pageDayTemplates: 'Σελίδα ημερήσιων προτύπων',
        pageRequests: 'Σελίδα λίστας αιτημάτων',
        pageAuditLogs: 'Σελίδα αρχείου ελέγχου',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Η συνεδρία λήγει',
      message: 'Η συνεδρία σας θα λήξει σε <strong>{{time}}</strong>. Παρακαλώ αποθηκεύστε την εργασία σας και συνδεθείτε ξανά για να συνεχίσετε.',
      dismiss: 'Απόρριψη',
      logoutNow: 'Αποσύνδεση τώρα',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Επιλέξτε 4 ζώνες ώρας',
      configure: 'Ρύθμιση ζωνών ώρας',
      reset: 'Επαναφορά',
      apply: 'Εφαρμογή',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Επιλογή τοποθεσίας',
      latitude: 'Γεωγραφικό πλάτος',
      longitude: 'Γεωγραφικό μήκος',
      clickToSelect: 'Κάντε κλικ στον χάρτη για να επιλέξετε τοποθεσία',
    },
    // Modal
    modal: {
      close: 'Κλείσιμο',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Αρχική',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Συντήρηση συστήματος',
    message: 'Το σύστημα επαναφέρεται για την επόμενη ημέρα άσκησης. Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία.',
    autoRefresh: 'Αυτή η σελίδα θα ανανεωθεί αυτόματα όταν το σύστημα είναι ξανά διαθέσιμο.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Τουλάχιστον 10 χαρακτήρες',
    uppercase: '1 κεφαλαίο γράμμα',
    lowercase: '1 πεζό γράμμα',
    digit: '1 ψηφίο',
    special: '1 ειδικός χαρακτήρας',
  },
};

export default el;
